// @auto-index

import supportTimeline from './support-timeline.jpg'
import temporal from './temporal.jpg'
import temporalTypes from './temporal-types.jpg'

export { default as supportTimeline } from './support-timeline.jpg'
export { default as temporal } from './temporal.jpg'
export { default as temporalTypes } from './temporal-types.jpg'

export default {
  supportTimeline,
  temporal,
  temporalTypes
}
